import { ApolloClient } from "apollo-client"
import { InMemoryCache } from "apollo-cache-inmemory"
import { HttpLink } from "apollo-link-http"
import { ApolloLink, from } from "apollo-link"
import fetch from "unfetch"
import {
  API_URL,
  APP_ID,
  // COMPANY_ID,
  CART_API_URL,
} from "./constants"
import { isAuthenticated } from "../utils/utils"
import { getDeviceId, inBrowser, decodeUserToken } from "@omnichannel/ace-b2b-elements"
// import decodeUserToken from "../helpers/decodeUserToken"
import { getCompanyId } from '../utils/utils'

let deviceId = undefined
if (inBrowser) {
  getDeviceId().then(result => {
    deviceId = result
  })
}

const appMiddleware = new ApolloLink((operation, forward) => {
  let bearerAccessToken = "x"
  let userInfo = null
  const accessToken = (inBrowser && localStorage.getItem("access-token")) || ""
  if (accessToken.length) {
    bearerAccessToken = `Bearer ${accessToken}`
    userInfo = decodeUserToken(accessToken)
  }

  const branch = JSON.parse(
    (inBrowser && localStorage.getItem("ace_app_branch")) || "{}"
  )
  let branchId = branch._id

  operation.setContext(({ headers = {} }) => {
    headers = {
      ...headers,
      appid: APP_ID,
      companyId: getCompanyId(),
      deviceId,
      user: userInfo ? userInfo._id : "",
      ...(branchId ? { branchId } : {}),
    }

    let token = ""
    if (isAuthenticated()) {
      if (token) {
        headers.token = token
      }
    }

    return { headers }
  })
  return forward(operation)
})

const httpLink = new HttpLink({
  uri: CART_API_URL ? CART_API_URL : `${API_URL}/cart/graphql`,
  fetch,
})

const cartClient = new ApolloClient({
  cache: inBrowser
    ? new InMemoryCache().restore(window.__APOLLO_STATE__)
    : new InMemoryCache(),
  link: from([appMiddleware, httpLink]),
})

export default cartClient
